module.exports = __webpack_public_path__ + "img/Startseite-Unten_Woche_2.e2590ac3.png";